<div class="card-header">
  <div class="grid-x">
    <div class="cell auto">
      <h4 appEllipsisWithTooltip [id]="'WIDGET_'.concat(widget.size)">{{tender.label}}</h4>
    </div>
    <div class="cell shrink">
        <span class="f-10 c-medium-gray padding-r-xs" *ngIf="widget.size === WidgetSize.LARGE">
          {{ 'widget.funding-tender.specification-description' | translate :{'creationDate': tender.creationDateTime | date: 'dd/MM/yyyy'} }}
        </span>
    </div>
  </div>
</div>

<div class="card-body vertical-center">
  <div class="d-block padding-h">
      <span class="d-block margin-h-l padding-v border-t border-b c-medium-gray" *ngIf="widget.size === WidgetSize.SMALL">
          {{ 'widget.funding-tender.specification-description' | translate :{'creationDate': tender.creationDateTime | date: 'dd/MM/yyyy'} }}
      </span>
    <div class="d-block margin-h-l padding-v border-t border-b">
      <div class="grid-x">
        <div class="cell shrink">
          <div class="badge-icon-scenario bg-info c-white">
            <span class="far fa-pen-alt" style="font-size:2rem;"></span>
          </div>
        </div>
        <div class="cell auto margin-t margin-l">
          <p class="label-scenario margin-reset">{{'widget.funding-tender.specification-main-text' | translate}}</p>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="card-footer">
  <a (click)="actionEvent.emit('widget.funding-tender.specifications');" [href]="goToFundingTenderSpecifications()"
     class="button insito">
      <span
        [title]="'widget.funding-tender.specifications' | translate">{{'widget.funding-tender.specifications' | translate}}</span>
  </a>
</div>


